import * as types from '../Actions/actionTypes';

const reducer = (state = { isError: false }, action) => {
    switch (action.type) {
        case types.ERROR:
            return {
                isError: true,
                text: action.payload
            }
            case types.CLEAR_ERROR:
                return {
                    isError: false
                }            
        case types.COMMIT:
            if (action.readyState === 'request')
                return {
                    isError: false
                };

            return state;
        default:
            return state;
    }
}

export default reducer;